export const treeViewCustomizations = {
    MuiTreeItem: {
        styleOverrides: {
            content: ({theme}) => ({
                // Match the selected background of the main nav (MenuContent's
                // ListItemButton). A clicked TreeItem is both selected AND focused,
                // and by default (see @mui/x-tree-view TreeItem) that stacks
                // focusOpacity on top of the selected tint — reading noticeably
                // darker than a nav item, which shows no persistent focus background
                // on a mouse click. Drop the extra focus tint so a selected gear
                // view/category looks identical to a selected nav item. The plain
                // [data-focused] (keyboard roving to an unselected row) is left alone
                // so keyboard focus stays visible.
                '&[data-selected][data-focused]': {
                    backgroundColor: `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})`,
                    '&:hover': {
                        backgroundColor: `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))`
                    }
                }
            })
        }
    }
};
